import React from "react";

import { EditorManager } from "./use-editor";
import s from "./editor.module.scss";
import { MutedDiv, DivPx } from "@moai/core";
import { Border } from "../border/border";

interface Props {
    editor: EditorManager;
}

export const Editor: React.FC<Props> = ({ editor }) => (
    <div className={s.container}>
        <div className={s.body}>
            <div ref={editor.refBody} />
        </div>
        {editor.params.statusVisible && (
            <>
                <Border color="strong" />
                <DivPx size={8} />
                <div className={s.status}>
                    <MutedDiv>
                        <div ref={editor.refStatus} />
                    </MutedDiv>
                </div>
                <DivPx size={8} />
            </>
        )}
    </div>
);
